import { collection, addDoc, updateDoc, deleteDoc, getDocs, doc } from 'firebase/firestore';
import { orderBy } from 'lodash';

import {
  LOAD_PRODUCTS,
  DELETE_PRODUCT,
  SET_PRODUCTS,
  SET_PRODUCT_TAGS,
} from './actionTypes';

import { PRODUCT_TAGS_COLLECTION, PRODUCTS_COLLECTION } from '../firebase/collections';
import Firebase from '../firebase';

const db = Firebase.db;

export const setProducts = (products) => ({ type: SET_PRODUCTS, products });

export const fetchProducts = () => (dispatch) => {
  dispatch({ type: LOAD_PRODUCTS });

  const productsCollection = collection(db, PRODUCTS_COLLECTION);

  return getDocs(productsCollection)
    .then((snapshot) => snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
    .then((products) => dispatch(setProducts(orderBy(products, 'sku'))));
};

export const createProduct = (product) => (dispatch) => {
  const path = collection(db, PRODUCTS_COLLECTION);
  return addDoc(path, product);
};

export const updateProduct = (productId, product) => (dispatch) => {
  const path = doc(db, PRODUCTS_COLLECTION, productId);
  return updateDoc(path, product);
};

export const deleteProduct = (productId) => (dispatch) => {
  const path = doc(db, PRODUCTS_COLLECTION, productId);
  return deleteDoc(path,)
    .then((docRef) => dispatch({ type: DELETE_PRODUCT, id: productId }));
}

export const setProductTags = (tags) => ({ type: SET_PRODUCT_TAGS, tags });

export const fetchProductTags = () => (dispatch) => {
  const tagsCollection = collection(db, PRODUCT_TAGS_COLLECTION);

  return getDocs(tagsCollection)
    .then((snapshot) => snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
    .then((tags) => dispatch(setProductTags(orderBy(tags, 'label'))));
};

export const createProductTag = (tag) => (dispatch) => {
  const path = collection(db, PRODUCT_TAGS_COLLECTION);
  return addDoc(path, tag);
};